/**
 * Seasonal looks for Pumpkin.
 *
 * Halloween is Eva's favourite holiday, so for the whole of October Pumpkin
 * wears her pumpkin costume and has a bat flying above her head (art in
 * src/assets/pumpkin-images/halloween/). It comes back every year with no
 * code change, and she's back to her everyday look on 1 November.
 *
 * Uses the device's local date, so it starts and ends at midnight where Eva
 * is (UK), not UTC.
 */

/** True on every day of October, any year, in local time. */
export function isHalloweenSeason(now: Date): boolean {
  return now.getMonth() === 9; // getMonth() is 0-based: 9 = October
}
